import { render, staticRenderFns } from "./AdminTransporterContractButton.vue?vue&type=template&id=fb041c0c"
import script from "./AdminTransporterContractButton.vue?vue&type=script&lang=js"
export * from "./AdminTransporterContractButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports